<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import ModuleTitle from '@/components/layout/ModuleTitle'

  export default {
    name: 'NavigationSubpages',
    components: {
      ModuleTitle,
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
  }
</script>
